import React from 'react';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { EmptyStateCardBody } from '../../../components/EmptyStateCard';

export const ProjectsTimeSheetsTableEmpty: React.FC = () => {
  const t = useNamespacedTranslation('timeTracking.projects.controlling.table');
  return <EmptyStateCardBody title={t('empty')} />;
};
